const isHttps = window.location.protocol === 'https:';
const CURRENT_PROTOCOL = isHttps ? 'https' : 'http';
const ENV_BASE_URL = process.env.BASE_URL;
let BASE_URL = '';
if (ENV_BASE_URL) {
    BASE_URL = ENV_BASE_URL;
}
else {
    BASE_URL = 'localhost:8000';
}
export { BASE_URL, CURRENT_PROTOCOL, isHttps };
